module.exports = __webpack_public_path__ + "static/img/图层49.99c792b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/facilitator/图层49.png
// module id = 1BDi
// module chunks = 0